import {Component, Inject, ViewEncapsulation, Input, Renderer2, ViewChild, AfterViewInit, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UploadedFile} from '@backend/modules/@files/models/uploaded-file.model';
import {TorchFilesService} from '@backend/modules/@files/services/torch-files.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-file-info-dialog',
  templateUrl: './file-info-dialog.component.html',
  styleUrls: ['./file-info-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FileInfoDialogComponent implements AfterViewInit, OnInit {

  @ViewChild('optixPreview')
  optixPreviewFrame;

  @Input()
  simpleView = false;

  @Input()
  superSimpleView = false;

  @Input()
  optixPreview = false;

  @Input()
  allowDelete = false;

  @Input()
  showPreview = true;

  file: UploadedFile;

  previewURL: string;
  previewStyle: string;
  cleanPreviewURL: SafeResourceUrl;
  previewIsVideo = false;
  loadingPreview = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              private dialogRef: MatDialogRef<FileInfoDialogComponent>,
              private sanitizer: DomSanitizer,
              private renderer: Renderer2,
              private filesService: TorchFilesService) {
    if (data.hasOwnProperty('downloadURL')) {
      this.file = data;
    } else if (data.hasOwnProperty('uploadedFile')) {
      this.file = data.uploadedFile;
      this.allowDelete = data.allowDelete;

      if (data.hasOwnProperty('superSimpleView')) {
        this.superSimpleView = true;
        this.simpleView = true;
      }
    } else {
      this.file = data;
    }

    if (data.hasOwnProperty('keepURL') && !!data.keepURL) {
      if (data.hasOwnProperty('previewURLRaw') && !!data.previewURLRaw) {
        this.previewURL = `${data.previewURLRaw.replace(/ /g, '%20')}`;
        this.previewStyle = `background-image: url(${this.previewURL})`;
        this.cleanPreviewURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewURL);
        this.previewIsVideo = FileInfoDialogComponent.isVideo(this.file.fileName);
      } else {
        this.previewURL = `${this.file.downloadURL.replace(/ /g, '%20')}`;
        this.previewStyle = `background-image: url(${this.previewURL})`;
        this.cleanPreviewURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewURL);
        this.previewIsVideo = FileInfoDialogComponent.isVideo(this.file.fileName);
      }
    } else if (this.file.downloadURL) {
      const downloadURL = this.file.downloadURL.replace('/api', '');

      this.previewURL = `${this.filesService.baseImageURL}${downloadURL.replace(/ /g, '%20')}`;
      this.previewStyle = `background-image: url(${this.previewURL})`;
      this.cleanPreviewURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewURL);
      this.previewIsVideo = FileInfoDialogComponent.isVideo(this.file.fileName);
    } else if (this.file.fileName) {
      const downloadURL = this.filesService.getURL(this.file.fileName);

      this.previewURL = `${downloadURL.replace(/ /g, '%20')}`;
      this.previewStyle = `background-image: url(${this.previewURL})`;
      this.cleanPreviewURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewURL);
      this.previewIsVideo = FileInfoDialogComponent.isVideo(this.file.fileName);
    }

    this.optixPreview = data.hasOwnProperty('optixPreview') && !!data.optixPreview;
    this.superSimpleView = data.hasOwnProperty('superSimpleView') && !!data.superSimpleView;
  }

  private static isVideo(fileName: string) {
    if (!!fileName) {
      const splitFileName = fileName.split('.');
      return !!splitFileName && splitFileName.length > 0 && splitFileName.pop() === 'mov';
    }
    return false;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (!!this.optixPreviewFrame) {
      this.renderer.listen(this.optixPreviewFrame.nativeElement, 'load', (e) => {
        this.loadingPreview = false;
      });
    }
  }

  deleteFile() {
    this.dialogRef.close('delete');
  }

  getWidth() {
    return 0.6 * Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  getHeight() {
    return 0.8 * Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.documentElement.clientHeight
    );
  }
}
